const Operatori = () => import("./Operatori")
const Operatore = () => import("./Operatore")
const Fase = () => import("./Fase")
const FaseLoadV2 = () => import("./load/FaseLoadV2")
const FaseSpeedV2 = () => import("./speed/FaseSpeedRoute.vue")
const Fasi = () => import("./Fasi")
const Schedulazioni = () => import("./Schedulazioni")
const Schedulazione = () => import("./Schedulazione")

const ProgrammiPiega = () => import("./ProgrammiPiega")

const RiordinoLavorazioni = () => import("./RiordinoLavorazioni")

import store from "../../store"
import { phaseLoadTrialDestination } from "./load/phaseLoadTrial.mjs"

const ifPhaseLoadTrial = (to, from, next) => next(phaseLoadTrialDestination(store, to))

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    next('/login')
}

const hasValidRouteParam = (value) => {
    return value !== undefined && value !== null && value !== "" && value !== "undefined" && value !== "null"
}

const ifValidOperatore = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        next('/login')
        return
    }

    if (!hasValidRouteParam(to.params.matricola) || !hasValidRouteParam(to.params.nome)) {
        if (hasValidRouteParam(to.params.ordine)) {
            next({ name: 'Ordine', params: { codice: to.params.ordine } })
            return
        }
        next({ name: 'av-operatori' })
        return
    }

    next()
}

export default [
    {
        path: '/av/fase-load-v2/:fase/:ordine?/:operazione?',
        name: 'av-fase-load-v2',
        meta: {menu: 'avanzamenti', title: 'Fase', access: {inheritFrom: 'page.av-fase'}},
        component: FaseLoadV2,
        beforeEnter: ifPhaseLoadTrial,
    },
    {
        path: '/av/fase-speed-v2/:fase/:ordine?/:operazione?',
        name: 'av-fase-speed-v2',
        meta: {menu: 'avanzamenti', title: 'Fase V2 velocità'},
        component: FaseSpeedV2,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/operatori/:presente?/:reparto?/:attivo?',
        name: 'av-operatori',
        meta: {menu: 'avanzamenti', title: 'Lista Operatori'},
        component: Operatori,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/operatore/:matricola/:nome/:ordine?/:operazione?',
        name: 'av-operatore',
        meta: {menu: 'avanzamenti', title: 'Operatore'},
        component: Operatore,
        beforeEnter: ifValidOperatore,
    },
    {
        path: '/av/fasi/',
        name: 'av-fasi',
        meta: {menu: 'avanzamenti', title: 'Lista Fasi'},
        component: Fasi,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/fase/:fase/:ordine?/:operazione?',
        name: 'av-fase',
        meta: {menu: 'avanzamenti', title: 'Fase'},
        component: Fase,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/v2/fase/:fase/:ordine?/:operazione?',
        name: 'av-fase-v2',
        redirect: to => ({ name: 'av-fase', params: to.params, query: to.query, hash: to.hash }),
    },
    {
        path: '/av/v2/fasi/',
        name: 'av-fasi-v2',
        redirect: to => ({ name: 'av-fasi', query: to.query, hash: to.hash }),
    },
    {
        path: '/av/schedulazioni/',
        name: 'av-schedulazioni',
        meta: {menu: 'avanzamenti', title: 'Lista Schedulazioni'},
        component: Schedulazioni,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/riordino/:carico?',
        name: 'av-riordinolavorazioni',
        meta: {menu: 'avanzamenti', title: 'Riordino Lavorazioni'},
        component: RiordinoLavorazioni,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/av/schedulazione/:fase',
        name: 'av-schedulazione',
        meta: {menu: 'avanzamenti', title: 'Schedulazione'},
        component: Schedulazione,
        beforeEnter: ifAuthenticated,
    },

    {
        path: '/av/programmipiega',
        name: 'av-progpiega',
        meta: {menu: 'avanzamenti', title: 'Programmi Piega'},
        component: ProgrammiPiega,
        beforeEnter: ifAuthenticated,
    },
]
